// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2Fvj_","select":"Header_select__6LOKe","clinic":"Header_clinic__3QXPI"};